import { Input, Typography } from "antd";
import { ErrorMessage } from "@hookform/error-message";
import { forwardRef } from "react";

const { TextArea } = Input;

const CustomInput = ({ label, divProps, errors, ...props }, ref) => {
    return (
        <div {...divProps}>
            {label && <Typography.Title level={5}>{label}</Typography.Title>}
            {props.textarea ? (
                <TextArea rows={4} />
            ) : (
                <Input ref={ref} {...props} value={props.value} />
            )}
            {errors && (
                <ErrorMessage
                    errors={errors}
                    name={props.name}
                    render={(data) => (
                        <Typography.Text type="danger">
                            * {data.message}
                        </Typography.Text>
                    )}
                />
            )}
        </div>
    );
};

export default forwardRef(CustomInput);
